import { inject, Injectable } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { RouterStateSnapshot, TitleStrategy } from '@angular/router';

const APP_NAME = 'Edjoin Admin';

/**
 * Injects into page components that need to set a dynamic title (e.g. after
 * loading data). For static page titles use the `title` property on the route.
 */
@Injectable({ providedIn: 'root' })
export class TitleService {
  private readonly title = inject(Title);

  set(pageTitle: string): void {
    this.title.setTitle(`${pageTitle} | ${APP_NAME}`);
  }
}

/**
 * Picks up the `title` field from the active route and formats it as
 * "Page Title | Edjoin Admin". Registered in app.config.ts.
 */
@Injectable()
export class AppTitleStrategy extends TitleStrategy {
  private readonly title = inject(Title);

  override updateTitle(snapshot: RouterStateSnapshot): void {
    const pageTitle = this.buildTitle(snapshot);
    this.title.setTitle(pageTitle ? `${pageTitle} | ${APP_NAME}` : APP_NAME);
  }
}
